export const DOMAIN_MAP = {
  test: 'tracking-test.',
  preview: 'tracking-preview.',
  develop: 'tracking-dev.',
  product: 'tracking.',
}
